// import React from "react";
// import {useTheme} from "@mui/material/styles";
// import Box from "@mui/material/Box";
// import {Link} from "react-router-dom";
// import Grid from "@mui/material/Grid";
// import Typography from "@mui/material/Typography";
// import Card from "@mui/material/Card";
// import CardActions from "@mui/material/CardActions";
// import CardContent from "@mui/material/CardContent";
// import LocalFloristIcon from "@mui/icons-material/LocalFlorist";
// import TimelineIcon from "@mui/icons-material/Timeline";
// import Button from "@mui/material/Button";
// import Avatar from "@mui/material/Avatar";
// import ScatterPlotIcon from "@mui/icons-material/ScatterPlot";
// import {useTranslation} from "react-i18next";

// export default function ExperimentTypeSelector() {
//     const theme = useTheme();
//     // init internationalization
//     const {t} = useTranslation();

//     return (
//         <Box
//             id="experiment-creator-container"
//             sx={{padding: theme.spacing(8, 2)}}
//         >
//             <Typography variant="h4" gutterBottom>
//                 {t("experimentTypeSelector.PageTitle")}
//             </Typography>
//             <Typography variant="body2">
//                 {t("experimentTypeSelector.PageInstructions")}
//             </Typography>
//             <br/>
//             <Grid
//                 container
//                 spacing={4}
//                 direction="row"
//                 justifyContent="flex-start"
//                 alignItems="start"
//             >
//                 <Grid item xl={3} md={5} xs={6}>
//                     <Link
//                         className="experiment-type-selector"
//                         to="/experiment-configuration?type=Classification"
//                     >
//                         <Card sx={{maxWidth: 359}} id="classification-card-action">
//                             <CardContent sx={{minHeight: 280}}>
//                                 <Grid
//                                     container
//                                     spacing={1}
//                                     alignItems="center"
//                                     sx={{marginBottom: theme.spacing(2)}}
//                                 >
//                                     <Grid item xs={4} sx={{maxWidth: 80}}>
//                                         <Avatar
//                                             sx={{
//                                                 bgcolor: theme.palette.secondary.light,
//                                                 color: theme.palette.secondary.main,
//                                             }}
//                                         >
//                                             <LocalFloristIcon/>
//                                         </Avatar>
//                                     </Grid>
//                                     <Grid item xs={2}>
//                                         <Typography gutterBottom variant="h6">
//                                             {t("experimentTypeSelector.ClassificationTitle")}
//                                         </Typography>
//                                     </Grid>
//                                 </Grid>
//                                 <Typography variant="body2" color="text.secondary">
//                                     {t("experimentTypeSelector.ClassificationDescription")}
//                                 </Typography>
//                             </CardContent>
//                             <CardActions>
//                                 <Button size="small">
//                                     {t("experimentTypeSelector.CreateExperimentButton")}
//                                 </Button>
//                             </CardActions>
//                         </Card>
//                     </Link>
//                 </Grid>
//                 <Grid item xl={3} md={5} xs={6}>
//                     <Link
//                         className="experiment-type-selector"
//                         to="/experiment-configuration?type=Regression"
//                     >
//                         <Card sx={{maxWidth: 359}} id="regression-card-action">
//                             <CardContent sx={{minHeight: 280}}>
//                                 <Grid
//                                     container
//                                     spacing={1}
//                                     alignItems="center"
//                                     sx={{marginBottom: theme.spacing(2)}}
//                                 >
//                                     <Grid item xs={4} sx={{maxWidth: 80}}>
//                                         <Avatar
//                                             sx={{
//                                                 bgcolor: theme.palette.secondary.light,
//                                                 color: theme.palette.secondary.main,
//                                             }}
//                                         >
//                                             <ScatterPlotIcon/>
//                                         </Avatar>
//                                     </Grid>
//                                     <Grid item xs={8}>
//                                         <Typography gutterBottom variant="h6">
//                                             {t("experimentTypeSelector.RegressionTitle")}
//                                         </Typography>
//                                     </Grid>
//                                 </Grid>
//                                 <Typography variant="body2" color="text.secondary">
//                                     {t("experimentTypeSelector.RegressionDescription")}
//                                 </Typography>
//                             </CardContent>
//                             <CardActions>
//                                 <Button size="small">
//                                     {t("experimentTypeSelector.CreateExperimentButton")}
//                                 </Button>
//                             </CardActions>
//                         </Card>
//                     </Link>
//                 </Grid>
//                 <Grid item xs={2} sx={{"display":"none"}}>
//                     <Link className="experiment-type-selector"  to="/experiment-configuration?type=Forecast">
//                         <Card sx={{maxWidth: 345}} id="forecast-card-action">
//                                 <CardContent sx={{minHeight: 230}}>
//                                     <Grid container spacing={1} alignItems="center"
//                                           sx={{marginBottom: theme.spacing(2)}}>
//                                         <Grid item xs={4} sx={{maxWidth: 80}}>
//                                             <Avatar sx={{ bgcolor: theme.palette.secondary.light, color: theme.palette.secondary.main, }}>
//                                                 <TimelineIcon/>
//                                             </Avatar>
//                                         </Grid>
//                                         <Grid item xs={8}>
//                                             <Typography gutterBottom variant="h6">{t('experimentTypeSelector.ForecastTitle')}</Typography>
//                                         </Grid>
//                                     </Grid>
//                                     <Typography variant="body2" color="text.secondary">
//                                         {t('experimentTypeSelector.ForecastDescription')}
//                                     </Typography>
//                                 </CardContent>
//                                 <CardActions>
//                                     <Button size="small">{t('experimentTypeSelector.CreateExperimentButton')}</Button>
//                                 </CardActions>
//                         </Card>
//                     </Link>
//                 </Grid>
//                     {/*
//                     // <Grid item xs={2}>
//                     //     <Link className="experiment-type-selector" to={`/experiment-configuration?type=AnomalyDetection`}>
//                     //         <Card sx={{maxWidth: 345}} id="anomaly-card-action">
//                     //                 <CardContent sx={{minHeight: 230}}>
//                     //                     <Grid container spacing={1} alignItems="center"
//                     //                           sx={{marginBottom: theme.spacing(2)}}>
//                     //                         <Grid item xs={4} sx={{maxWidth: 80}}>
//                     //                             <Avatar sx={{ bgcolor: theme.palette.secondary.light, color: theme.palette.secondary.main, }}>
//                     //                                 <QueryStatsIcon/>
//                     //                             </Avatar>
//                     //                         </Grid>
//                     //                         <Grid item xs={8}>
//                     //                             <Typography gutterBottom variant="h6">{t('experimentTypeSelector.AnomalyDetectionTitle')}</Typography>
//                     //                         </Grid>
//                     //                     </Grid>
//                     //                     <Typography variant="body2" color="text.secondary">
//                     //                         {t('experimentTypeSelector.AnomalyDetectionDescription')}
//                     //                     </Typography>
//                     //                 </CardContent>
//                     //                 <CardActions>
//                     //                     <Button size="small">{t('experimentTypeSelector.CreateExperimentButton')}</Button>
//                     //                 </CardActions>
//                     //         </Card>
//                     //     </Link>
//                     //</Grid>
//                     */}
//                 {/* <Grid item xs={3}> */}
//                 {/*    <Link className="experiment-type-selector" to="/new-dataset"> */}
//                 {/*        <Card sx={{maxWidth: 350}} id="more-examples-card-action"> */}
//                 {/*                <CardContent sx={{minHeight: 280}}> */}
//                 {/*                    <Grid container spacing={1} alignItems="center" */}
//                 {/*                          sx={{marginBottom: theme.spacing(2)}}> */}
//                 {/*                        <Grid item xs={4} sx={{maxWidth: 80}}> */}
//                 {/*                            <Avatar sx={{ bgcolor: theme.palette.secondary.light, color: theme.palette.secondary.main, }}> */}
//                 {/*                                <QuestionMarkIcon/> */}
//                 {/*                            </Avatar> */}
//                 {/*                        </Grid> */}
//                 {/*                        <Grid item xs={8}> */}
//                 {/*                            <Typography gutterBottom variant="h6">{t('experimentTypeSelector.NotSureTitle')}</Typography> */}
//                 {/*                        </Grid> */}
//                 {/*                    </Grid> */}
//                 {/*                    <Typography variant="body2" color="text.secondary"> */}
//                 {/*                        {t('experimentTypeSelector.NotSureDescription')} */}
//                 {/*                    </Typography> */}
//                 {/*                </CardContent> */}
//                 {/*                <CardActions> */}
//                 {/*                    <Button size="small">{t('experimentTypeSelector.ShowExamplesButton')}</Button> */}
//                 {/*                </CardActions> */}
//                 {/*        </Card> */}
//                 {/*    </Link> */}
//                 {/* </Grid> */}
//             </Grid>
//         </Box>
//     );
// }

import React from "react";
import { useTheme } from "@mui/material/styles";
import Box from "@mui/material/Box";
import { Link } from "react-router-dom";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import Card from "@mui/material/Card";
import CardActions from "@mui/material/CardActions";
import CardContent from "@mui/material/CardContent";
import LocalFloristIcon from "@mui/icons-material/LocalFlorist";
import Button from "@mui/material/Button";
import Avatar from "@mui/material/Avatar";
import ScatterPlotIcon from "@mui/icons-material/ScatterPlot";
import { useTranslation } from "react-i18next";

export default function ExperimentTypeSelector() {
  const theme = useTheme();
  const { t } = useTranslation();

  // Card data for easy extension
  const cards = [
    {
      id: "classification",
      title: t("experimentTypeSelector.ClassificationTitle"),
      description: t("experimentTypeSelector.ClassificationDescription"),
      icon: <LocalFloristIcon />,
      link: "/experiment-configuration?type=Classification",
      iconBg: theme.palette.secondary.light,
      iconColor: theme.palette.secondary.main,
    },
    {
      id: "regression",
      title: t("experimentTypeSelector.RegressionTitle"),
      description: t("experimentTypeSelector.RegressionDescription"),
      icon: <ScatterPlotIcon />,
      link: "/experiment-configuration?type=Regression",
      iconBg: theme.palette.secondary.light,
      iconColor: theme.palette.secondary.main,
    },
    // You can add more types here (example: forecast, anomaly detection...)
    // {
    // id: "forecast",
    // title: t("experimentTypeSelector.ForecastTitle"),
    // description: t("experimentTypeSelector.ForecastDescription"),
    // icon: <TimelineIcon />,
    // link: "/experiment-configuration?type=Forecast",
    // iconBg: theme.palette.info.light,
    // iconColor: theme.palette.info.main,
    // },
  ];

  return (
    <Box
      id="experiment-creator-container"
      sx={{
        padding: { xs: theme.spacing(3, 1), md: theme.spacing(8, 2) },
        background: theme.palette.background.default,
        minHeight: "100vh",
      }}
    >
      <Typography variant="h4" gutterBottom>
        {t("experimentTypeSelector.PageTitle")}
      </Typography>
      <Typography variant="body2" gutterBottom>
        {t("experimentTypeSelector.PageInstructions")}
      </Typography>
      <Grid
        container
        spacing={3}
        justifyContent="center"
        alignItems="stretch"
        sx={{ mt: 2 }}
      >
        {cards.map((card) => (
          <Grid item key={card.id} xs={12} sm={8} md={5} xl={3}>
            <Link
              className="experiment-type-selector"
              to={card.link}
              style={{ textDecoration: "none" }}
            >
              <Card
                sx={{
                  width: "100%",
                  maxWidth: { xs: "100%", sm: 350 },
                  margin: "auto",
                  height: "100%",
                  display: "flex",
                  flexDirection: "column",
                  transition: "box-shadow 0.2s",
                  "&:hover": {
                    boxShadow: 8,
                  },
                }}
                elevation={4}
              >
                <CardContent sx={{ flexGrow: 1 }}>
                  <Grid
                    container
                    spacing={1}
                    alignItems="center"
                    sx={{ mb: theme.spacing(2) }}
                  >
                    <Grid item>
                      <Avatar
                        sx={{
                          bgcolor: card.iconBg,
                          color: card.iconColor,
                          width: 56,
                          height: 56,
                          boxShadow: 2,
                        }}
                      >
                        {card.icon}
                      </Avatar>
                    </Grid>
                    <Grid item>
                      <Typography variant="h6" gutterBottom>
                        {card.title}
                      </Typography>
                    </Grid>
                  </Grid>
                  <Typography variant="body2" color="text.secondary">
                    {card.description}
                  </Typography>
                </CardContent>
                <CardActions>
                  <Button size="small">
                    {t("experimentTypeSelector.CreateExperimentButton")}
                  </Button>
                </CardActions>
              </Card>
            </Link>
          </Grid>
        ))}
      </Grid>
    </Box>
  );
}

/* <Grid item xs={3}> */
// {/* <Link className="experiment-type-selector" to="/new-dataset"> */}
// {/* <Card sx={{maxWidth: 350}} id="more-examples-card-action"> */}
// {/* <CardContent sx={{minHeight: 280}}> */}
// {/* <Grid container spacing={1} alignItems="center" */}
// {/* sx={{marginBottom: theme.spacing(2)}}> */}
// {/* <Grid item xs={4} sx={{maxWidth: 80}}> */}
// {/* <Avatar sx={{ bgcolor: theme.palette.secondary.light, color: theme.palette.secondary.main, }}> */}
// {/* <QuestionMarkIcon/> */}
// {/* </Avatar> */}
// {/* </Grid> */}
// {/* <Grid item xs={8}> */}
// {/* <Typography gutterBottom variant="h6">{t('experimentTypeSelector.NotSureTitle')}</Typography> */}
// {/* </Grid> */}
// {/* </Grid> */}
// {/* <Typography variant="body2" color="text.secondary"> */}
// {/* {t('experimentTypeSelector.NotSureDescription')} */}
// {/* </Typography> */}
// {/* </CardContent> */}
// {/* <CardActions> */}
// {/* <Button size="small">{t('experimentTypeSelector.ShowExamplesButton')}</Button> */}
// {/* </CardActions> */}
// {/* </Card> */}
// {/* </Link> */}
// {/* </Grid> */}
